"use client";

import type { FC } from "react";

import { Link } from "@ui/components/core/Link";
import { ICON_ALIGN_OPTIONS } from "@ui/tokens/icon-types";

import BackgroundForegroundImage from "./BackgroundForegroundImage";
import type { AccordionSlidesLazyAssetProps } from "./AccordionSlidesShared";

export const AccordionSlidesAssetImage: FC<AccordionSlidesLazyAssetProps> = ({
  asset,
  animationKey,
  isPreload,
  item,
}) => {
  if (asset.type !== "backgroundForegroundImage" || !asset.foreground) {
    return null;
  }

  return (
    <BackgroundForegroundImage
      animationKey={animationKey}
      background={asset.background}
      className='tw-w-full'
      foreground={asset.foreground}
      overlay={asset.overlay}
      theme={asset.theme}
    >
      {!isPreload && item?.link && (
        <div className='tw-absolute tw-inset-0 tw-z-20 tw-flex tw-items-center tw-justify-center'>
          <Link
            {...item.link}
            asButton
            buttonVariants={{
              variant: "primary",
              size: "lg",
            }}
            icon={item.linkIcon || undefined}
            iconPosition={ICON_ALIGN_OPTIONS.BEFORE}
          >
            {item.link.label}
          </Link>
        </div>
      )}
    </BackgroundForegroundImage>
  );
};
